import * as Shape from './shape';
export * from '@antv/g-base';
export { default as Canvas } from './canvas';
export { default as Group } from './group';
export { Shape };
export var version = '0.5.6';
//# sourceMappingURL=index.js.map